import styled from "@emotion/styled";
import {
  FONT_SIZE_MEDIUM,
  BUTTON_PRIMARY_GRADIENT,
  COLOR_TERTIARY,
  BUTTON_PRIMARY_COLOR_GRADIENT,
  BUTTON_DISABLED_COLOR,
  HEADER_FONT_FAMILY,
  TEXT_FONT_FAMILY,
  FONT_SIZE_SMALL,
  COLOR_PRIMARY_BUTTON,
} from "../theme";

export const PrimaryButton = styled.button`
  width: 100%;
  height: 48px;
  border: none;
  border-radius: 100px;
  color: ${COLOR_TERTIARY};
  background: ${BUTTON_PRIMARY_COLOR_GRADIENT};
  font-size: ${FONT_SIZE_MEDIUM};
  font-family: ${HEADER_FONT_FAMILY};
  font-weight: 600;
  cursor: pointer;
  text-align: center;
  padding: 8px;
  padding: 4px 24px;
  transition: all 100ms ease-in-out;

  &:hover {
    background: ${BUTTON_PRIMARY_GRADIENT};
  }
  &:disabled {
    background: ${BUTTON_DISABLED_COLOR};
    cursor: not-allowed;
  }
`;

export const ProgressButton = styled(PrimaryButton)<{ progress?: number }>`
  &:disabled {
    background: linear-gradient(
      90deg,
      ${COLOR_PRIMARY_BUTTON} ${({ progress }) => `${progress}%`},
      ${BUTTON_DISABLED_COLOR} ${({ progress }) => `${progress}%`}
    );
    cursor: not-allowed;
  }
`;

export const PrimaryButtonSmall = styled(PrimaryButton)`
  height: 40px;
  font-family: ${TEXT_FONT_FAMILY};
  font-size: ${FONT_SIZE_SMALL};
  gap: 8px;
`;

export const PrimaryButtonSmallNormalWeight = styled(PrimaryButtonSmall)`
  font-weight: 400;
`;
